// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesRedblue = {
  redblueActivity: "红蓝活动",
  redblueActivityCamp: "红蓝活动阵营",
  redblueActivityMember: "红蓝活动成员",
  redblueActivitySeat: "红蓝活动席位",
  redblueActivityTask: "红蓝活动任务",
  redblueAuth: "红蓝认证",
  redblueDirectorActivityTasks: "红蓝导演任务",
  redblueDirectorDispatchTarget: "红蓝导演分发目标",
  redblueDirectorEventSubject: "红蓝导演事件主体",
  redblueDirectorNoticeTarget: "红蓝导演通知目标",
  redblueJudgeScoreRecord: "红蓝评分记录",
  redblueMember: "红蓝成员",
  redblueParticipant: "红蓝参演成员",
  redblueParticipantReport: "红蓝参演报告",
  redblueParticipantReportTemplate: "红蓝参演报告模板",
  redblueScheme: "红蓝方案",
  redblueSchemeVersion: "红蓝方案版本",
  redblueDirector: "红蓝导演",
  redblueDirectorActivityTask: "红蓝导演活动任务",
  redblueDirectorTaskAssignment: "红蓝导演任务分配",
  redblueDirectorTaskCodes: "红蓝导演任务编号",
  redblueEnvironment: "红蓝环境",
  redblueIntelligence: "红蓝智能生成",
  redblueJudge: "红蓝裁判",
  redblueJudgeFinalScore: "红蓝最终评分",
  redblueObserver: "红蓝观察员",
  redblueParticipantActivityTask: "红蓝参演活动任务",
  redblueSchemeDesign: "红蓝方案设计",
  redblueSchemeTopologyBinding: "红蓝方案拓扑绑定",
  redblueSchemeTopologySync: "红蓝方案拓扑同步",
  redblueBusinessEvent: "红蓝业务事件",
} as const;
